
import { Record } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { PledgeSummaryResponse_$reflection } from "../Shared.js";
import { record_type, list_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { sortByDescending, sortBy, reverse, cons, fold, isEmpty as isEmpty_1, empty as empty_1 } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { compare } from "../../fable_modules/fable-library-js.5.3.0/Date.js";

export class CategorizedPledges extends Record {
    constructor(Unfulfilled, Active, Past) {
        super();
        this.Unfulfilled = Unfulfilled;
        this.Active = Active;
        this.Past = Past;
    }
}

export function CategorizedPledges_$reflection() {
    return record_type("Shared.PledgeCategorization.CategorizedPledges", [], CategorizedPledges, () => [["Unfulfilled", list_type(PledgeSummaryResponse_$reflection())], ["Active", list_type(PledgeSummaryResponse_$reflection())], ["Past", list_type(PledgeSummaryResponse_$reflection())]]);
}

export const empty = new CategorizedPledges(empty_1(), empty_1(), empty_1());

export function isEmpty(c) {
    if (isEmpty_1(c.Unfulfilled) && isEmpty_1(c.Active)) {
        return isEmpty_1(c.Past);
    }
    else {
        return false;
    }
}

export function categorize(pledges) {
    const patternInput = fold((tupledArg, pledge) => {
        const u = tupledArg[0];
        const a = tupledArg[1];
        const p = tupledArg[2];
        const matchValue_1 = pledge.Challenge.ChallengeStatus;
        let matchResult;
        if (pledge.Status === "active") {
            switch (matchValue_1) {
                case "finalized":
                case "finalizing": {
                    matchResult = 0;
                    break;
                }
                case "published":
                case "pledged":
                case "active": {
                    matchResult = 1;
                    break;
                }
                default:
                    matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
        switch (matchResult) {
            case 0:
                return [cons(pledge, u), a, p];
            case 1:
                return [u, cons(pledge, a), p];
            default:
                return [u, a, cons(pledge, p)];
        }
    }, [empty_1(), empty_1(), empty_1()], pledges);
    return new CategorizedPledges(reverse(patternInput[0]), sortBy((p_1) => p_1.Challenge.EndDate, patternInput[1], {
        Compare: (x, y) => (compare(x, y) | 0),
    }), sortByDescending((p_2) => p_2.CreatedAt, patternInput[2], {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }));
}

//# sourceMappingURL=PledgeCategorization.js.map
